import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Caption, Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const parts = [{
  name: 'Data',
  tone: INK.grey
}, {
  name: 'Models',
  tone: INK.gold
}, {
  name: 'Deterministic functions',
  tone: INK.blue
}, {
  name: 'Workflows',
  tone: INK.violet
}, {
  name: 'Industry assets',
  tone: INK.violet
}, {
  name: 'Institutional memory',
  tone: INK.emerald
}];
function Operator({
  children
}: {
  children: string;
}) {
  return <span className="self-center text-[1.8cqw] leading-none text-white/35" style={SERIF} aria-hidden data-id="element-379" data-mp="2nfk2k3378qb3">
      {children}
    </span>;
}
export function PlatformSolutionSlide() {
  return <Slide data-id="element-380" data-mp="2dlthl86a6y05">
      <Eyebrow data-id="element-381" data-mp="7qsg0vh7zexm">The solution · DiligenceGPT™</Eyebrow>
      <Title className="mt-[2.2cqh] max-w-[70%]" data-id="element-382" data-mp="7s3hupr3ucm3">
        The AI + Data Infrastructure Layer for Private Markets.
      </Title>

      <div className="mt-auto flex items-stretch gap-[0.9cqw]" data-id="element-383" data-mp="bq9l3nsqia29">
        {parts.map((p, i) => <React.Fragment key={p.name} data-id="element-384" data-mp="a6wywhfy5k0i" data-mpi={i}>
            {i > 0 && <Operator data-id="element-385" data-mp="5aomvcx1q6xk">+</Operator>}
            <Reveal delay={0.05 * i} className="flex flex-1 flex-col justify-between border border-white/12 bg-white/[0.025] px-[1.1cqw] py-[2.6cqh]" data-id="element-386" data-mp="59n04b6o3w00">
              <span className="block h-px w-[2.2cqw]" style={{
            background: p.tone
          }} data-id="element-387" data-mp="f087an0eq8uj" />
              <p className="mt-[6cqh] text-[1.35cqw] leading-tight text-[#F4F7FC]" style={SERIF} data-id="element-388" data-mp="3ngb41xpzed43">
                {p.name}
              </p>
            </Reveal>
          </React.Fragment>)}
      </div>

      <div className="mt-[2.4cqh] flex items-center gap-[1.4cqw]" data-id="element-389" data-mp="19wf6o3toa3e">
        <Operator data-id="element-390" data-mp="3secyfesuxyuv">=</Operator>
        <Reveal delay={0.36} className="flex flex-1 items-center justify-between border border-[#3B8CFF]/55 bg-[#3B8CFF]/[0.08] px-[2cqw] py-[3cqh]" data-id="element-391" data-mp="3sd1kim5p7aq1">
          <p className="text-[3cqw] leading-none text-[#F4F7FC]" style={SERIF} data-id="element-392" data-mp="17nc78dkn7wzg">
            DiligenceGPT™
          </p>
          <Label tone={INK.blue} data-id="element-393" data-mp="1er26efppuvk9">Infrastructure around the models — not another chatbot</Label>
        </Reveal>
      </div>

      <Caption className="mt-[3cqh] max-w-[60%]" data-id="element-394" data-mp="1jsrhfvcxv98c">
        Foundation models supply reasoning. DiligenceGPT™ supplies the data,
        structure and memory that make it dependable for professional work.
      </Caption>
    </Slide>;
}